import { Component, ElementRef, ViewChild } from "@angular/core";
import { Observable } from "rxjs";
import { UserDto } from "@api";
import * as FromUser from "src/app/store/user/selectors";
import { SafeUrl } from "@angular/platform-browser";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import { LoadingController } from "@ionic/angular";
import { AppRoutes } from "../../constants";

@Component({
  selector: "app-iframe",
  templateUrl: "./iframe.page.html",
  styleUrls: ["./iframe.page.scss"],
})
export class IframePage {
  @ViewChild("iframe", { static: false }) public iframe: ElementRef<HTMLIFrameElement>;

  public title: string;
  public iframeSrc: SafeUrl;
  public breadcrumbs = [{ name: "Dashboard", link: `/${AppRoutes.webBuilder}/dashboard` }];
  public user$: Observable<UserDto> = this.store.select(FromUser.selectUser);
  public canShowIframe: boolean;

  private loading: HTMLIonLoadingElement;

  constructor(private store: Store<RootState>, private loadingController: LoadingController) {
    this.showLoading().then(() => (this.canShowIframe = true));
  }

  public hideLoading(): void {
    this.loading?.dismiss();
  }

  private async showLoading(): Promise<void> {
    this.loading = await this.loadingController.create();
    this.loading?.present();
  }
}
